// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2y1NEs2ccjIb","icon":"_23vilO_O51-L","link":"_2ep7tRFatN9r"};